module.exports = __webpack_public_path__ + "static/img/WechatIMG12931.10a3f89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/home/WechatIMG12931.png
// module id = AUeN
// module chunks = 4